import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchDashboardData = createAsyncThunk(
    'dashboardData/fetchData',
    async (_, { rejectWithValue }) => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 20000);

        try {
            const response = await fetch('/meonsupport/dashboard_data', {
                signal: controller.signal,
            });

            const data = await response.json();

            if (data.msg === 'Logged out') {
                return rejectWithValue('Session expired. Please login again.');
            }

            return data;
        } catch (error) {
            if (error.name === 'AbortError') {
                return rejectWithValue('Request timed out.');
            }
            return rejectWithValue(error.message);
        } finally {
            clearTimeout(timeoutId);
        }
    }
);

const dashboardDataSlice = createSlice({
    name: 'dashboardData',
    initialState: {
        tickets: {
            all_ticket: null,
            prog_ticket: null,
            todo_ticket: null,
            hold_ticket: null,
            test_ticket: null,
            done_ticket: null,
            delivered_ticket: null,
        },
        session_response: '',
        session_flag: false,
        timeout_flag: false,
        loading: false,
        error: null,
    },
    reducers: {
        resetSessionFlag: (state) => {
            state.session_flag = false;
        },
        resetTimeoutFlag: (state) => {
            state.timeout_flag = false;
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchDashboardData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchDashboardData.fulfilled, (state, action) => {
            state.loading = false;
            state.tickets = action.payload;
        })
        .addCase(fetchDashboardData.rejected, (state, action) => {
            state.loading = false;
            if (action.payload === "Session expired. Please login again.") {
                state.session_response = action.payload;
                state.session_flag = true;
            } else if (action.payload === "Request timed out.") {
                state.timeout_flag = true;
            } else {
                state.error = action.payload;
            }
        });
    }
});

export const { resetSessionFlag, resetTimeoutFlag } = dashboardDataSlice.actions;

export default dashboardDataSlice.reducer;